export function initRecoveryModalScripts(parent) {

    const recoveryForm = $(parent).find(".recovery-form form")
    const errorBlock = $(parent).find(".recovery-form-errors")
    const strContent = `
    <div style="max-width: 430px;" class="modal-alert-with-icon">
        <div class="title">Письмо успешно отправлено</div>
        <p>На ваш адрес электронной почты было отправлено письмо с инструкцией по восстановлению пароля.</p>
        <p style="margin-top: 0">Пожалуйста, проверьте свой почтовый ящик и следуйте указаниям. </p>
        <button class="blue-btn btn-close">Закрыть</button>
    </div>`;

    jQuery.validator.addMethod("isEmailValid", function (value, element) {
        var re =
            /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(value);
    })

    recoveryForm.validate({
        submitHandler: function (form) {

            const formData = {
                USER_EMAIL: $(form).find("#RECOVERY_USER_EMAIL").val(),
                sessid: $(form).find("input[name='sessid']").val()
            };

            $.ajax({
                type: "POST",
                url: "/local/ajax/recovery.php",
                data: formData,
                dataType: "json",
                encode: true,
            }).done(function (data) {
                if (data.success === "Y") {
                    const regModal = App.components.Modal.getModalById("authModal")
                    regModal.setContent(strContent)
                    regModal.setupCloseBtnEvent()
                } else {
                    errorBlock.text(data.error)
                    console.log(data.error)
                }
            }).fail(function (res, exception) {
                console.log(res);
            });
        },
        rules: {
            "USER_EMAIL": {
                required: true,
                isEmailValid: true,
                email: true,
            },
        },
        messages: {
            "USER_EMAIL": {
                required:
                    "Обязательно заполнить. Логином должен быть ваш действующий адрес эл.почты.",
                email:
                    "Ваш адрес электронной почты должен быть в формате example@domain.ru",
                isEmailValid:
                    "Ваш адрес электронной почты должен быть в формате example@domain.ru",
            },
        },
        focusInvalid: true
    })

};
